import React from 'react';
import moment from 'moment';

const DEFAULT_FORMAT = 'L';

type DateFormatProps = {
  date: number | string
  format?: string
}

export default function DateFormat({
  date,
  format,
  ...rest
}: DateFormatProps) {
  const dateMoment = moment(date);
  return <span {...rest}>{dateMoment.isValid() ? dateMoment.format(format || DEFAULT_FORMAT) : '—'}</span>
}

